import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { LandingPageComponent } from 'app/library/landing-page-component/models/landing-page-component.model';
import { IModuleDuration } from 'app/library/module/interfaces/module-duration.interface';
import { PostingType } from 'app/library/posting/models/posting-type.model';
import { UserExtendedAttributeWithValue } from 'app/projects/user/src/lib/models/user-attribute-with-value';
import { ICourseOfferingLandingPageOverviewQuery } from '../interfaces/course-offering-landing-page-overview.query.interface';
import { CourseOfferingLandingPageBreadcrumb } from './course-offering-landing-page-breadcrumb.model';

// @dynamic
export class CourseOfferingLandingPageOverview {
    id: string;
    courseOffering: {
        id: string;
        attributes: UserExtendedAttributeWithValue[];
        bookedAsParticipant: boolean;
        isSelfPaced: boolean;
        duration: IModuleDuration | null;
    };
    status: string;
    shortDescription: string;
    title: string;
    language: string;
    image: MaxbrainImage | null;
    postingType: PostingType;
    pageComponents: LandingPageComponent[];
    breadcrumbs: CourseOfferingLandingPageBreadcrumb[];

    constructor(query: ICourseOfferingLandingPageOverviewQuery) {
        this.id = query.id.toString();
        this.courseOffering = {
            id: query.course_offering.id.toString(),
            attributes: query.course_offering.attributes
                ? query.course_offering.attributes.map((attributeWithValue) => new UserExtendedAttributeWithValue(attributeWithValue.attribute, attributeWithValue.value))
                : [],
            bookedAsParticipant: query.course_offering.booked_as_participant ?? false,
            isSelfPaced: !!query.course_offering.is_self_paced,
            duration: query.course_offering.duration ?? null,
        };
        this.status = query.status;
        this.title = query.title;
        this.language = query.language;
        this.shortDescription = query.short_description;
        this.image = query.image ? new MaxbrainImage(query.image) : null;
        this.postingType = new PostingType(query.posting_type);

        if (query.page_components) {
            this.pageComponents = query.page_components.map((component) => new LandingPageComponent(component));
        }

        if (query.breadcrumbs) {
            this.breadcrumbs = query.breadcrumbs.map((breadcrumb) => new CourseOfferingLandingPageBreadcrumb(breadcrumb));
        }
    }
}
